<script setup lang="ts">
import type { GetRepositoriesQuery } from './Repositories.generated'
import { getListOfNodes } from '~/utils/relay'
import { GetRepositoriesDocument } from './Repositories.generated'

const { enabled: areSleuthSkillsEnabled } = useFlag('SLEUTH_SKILLS')

type SkillsRepository = GetRepositoriesQuery['organization']['skillsRepositories']['edges'][0]['node']
export type RepositoryNavigationItem = ReturnType<typeof skillsRepositoryToNavigationItem>

const { data, isFetching, isDone } = useQuery({
  query: GetRepositoriesDocument,
  tags: ['repositories'],
  paused: computed(() => !areSleuthSkillsEnabled.value),
})

function skillsRepositoryToNavigationItem(skillsRepository: SkillsRepository) {
  const repo = skillsRepository.repository
  return {
    gid: skillsRepository.gid,
    label: `${repo.owner}/${repo.name}`,
    defaultOpen: false,
  }
}

const repositories = computed(() => {
  return getListOfNodes(data.value?.organization?.skillsRepositories)
    .filter(skillsRepo => skillsRepo.repository?.gid)
    .map(skillsRepositoryToNavigationItem)
})

const openRepositories = ref(true)
</script>

<template>
  <Transition>
    <div v-show="areSleuthSkillsEnabled && !isFetching && isDone && repositories.length > 0" class="mt-4">
      <Details v-model="openRepositories">
        <template #summary>
          <div class="ml-4 py-1 text-sm font-medium text-gray-600 dark:text-gray-400">
            Repositories
          </div>
        </template>
        <NavigationRepositoryItems :repositories="repositories" />
      </Details>
    </div>
  </Transition>
</template>
